/**
 * API 服务配置文件
 *
 * 提供用于连接各个后端服务的配置信息。
 * 渲染服务（manim）已全部通过 hammerath-api 代理，不再直连 manim 服务。
 */

const isDev = () => {
  return process.env.NODE_ENV === 'development' || window.location.hostname === 'localhost';
};

const getBaseUrl = (service) => {
  if (service === 'AUTH_SERVICE') {
    if (isDev()) {
      const port = process.env.REACT_APP_AUTH_SERVICE_PORT;
      return `http://localhost:${port}`;
    }
    return process.env.REACT_APP_AUTH_SERVICE_PATH;
  }
  return '';
};

export const API_CONFIG = {
  // 用户认证服务 API
  AUTH: {
    BASE_URL: getBaseUrl('AUTH_SERVICE'),
    LOGIN: '/login',
    REGISTER: '/register',
    VERIFY: '/verify_token',
    LOGOUT: '/logout',
  },
};

export default API_CONFIG;
